import React from "react";
import { renderRichText, storyblokEditable } from "@storyblok/react";
// import { useNavigate } from "react-router-dom";

import "./FontTest.css";
import { FontTestModel } from "./FontTestModel";

const FontTest: React.FC<{ blok: FontTestModel }> = ({ blok }) => {
  // const navigate = useNavigate();
  const bodyHTML = renderRichText(blok.richtext) || "";
  console.log("blok");
  console.log(blok);

  // const handleClick = () => {
  //   if (blok.link?.cached_url) {
  //     if (blok.link?.linktype === "story") {
  //       navigate(`/${blok.link.cached_url}`);
  //     } else {
  //       const url = new URL(blok.link.cached_url, window.location.origin);
  //       window.location.href = url.href;
  //     }
  //   }
  // };

  return (
    <div
      // onClick={handleClick}
      {...storyblokEditable(blok)}
      className="info-text-banner"
      // style={{ backgroundColor: blok.backgroundColor?.color }}
    >
      <div className="container">
        <div className="Text">
          <span
            style={{
              fontSize: `${blok.textSize}px`,
              fontFamily: blok.textFont,
              lineHeight: `${blok.lineHeight}px`,
            }}
          >
            {blok.text}
          </span>
        </div>

        <div className="SubText">
          <div dangerouslySetInnerHTML={{ __html: bodyHTML }}></div>
        </div>
      </div>
    </div>
  );
};

export default FontTest;
